module.exports = __webpack_public_path__ + "img/item9.ba87a8f6.png";